const WEBHOOK_URL = "https://twenty-lead-integration.logicoretech.workers.dev/webhook/site";
const WEBHOOK_SECRET = "43504250e74689170d0c7561864ca24c3fc89541891d4362";

export type LeadWebhookPayload = {
  company?: string;
  contactName?: string;
  email?: string;
  phone?: string;
  role?: string;
  tradeLane?: string;
  website?: string;
};

/**
 * Best-effort mirror of a lead to the external webhook.
 * Never throws — failures must not affect the main submission flow.
 */
export async function sendLeadToWebhook(data: LeadWebhookPayload): Promise<void> {
  try {
    await fetch(WEBHOOK_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Webhook-Secret": WEBHOOK_SECRET,
      },
      body: JSON.stringify({
        company: data.company ?? "",
        contactName: data.contactName ?? "",
        email: data.email ?? "",
        phone: data.phone ?? "",
        role: data.role ?? "",
        tradeLane: data.tradeLane ?? "",
        landingUrl: window.location.href,
        website: data.website ?? "",
      }),
    });
  } catch {
    // silently ignored — secondary delivery channel
  }
}
